// extracted by mini-css-extract-plugin
module.exports = {"auctionHeader":"_1CUee","stopAuction":"_1hp15","stopAuctionModal":"_2Q_-j"};